<template>
  <v-dialog
    :value="enableDialog"
    persistent
    width="900"
  >
    <v-card>
      <v-card-title>
        売上詳細
      </v-card-title>
      <v-divider />
      <v-card-text
        v-if="dealDetail"
        style="max-height: 60vh;overflow-y: auto;"
      >
        <v-row dense>
          <v-col cols="12" md="8">
            <div class="overline">
              売上品目
            </div>
            <h4>{{ dealDetail.sales_item_price_code }}：{{ dealDetail.sales_item_price_name }}&nbsp;</h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- マニフェスト数量／回収数量／JWNET取り扱い品目 -->
        <v-row
          v-if="dealDetail.manifest_available"
          dense
        >
          <v-col cols="12" md="4">
            <div class="overline">
              マニフェスト数量
            </div>
            <h4 class="text-right">
              <span v-if="dealDetail.manifest_quantity">
                {{ dealDetail.manifest_quantity | comma_format }}&nbsp;kg&emsp;
              </span>&nbsp;
            </h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="4">
            <div class="overline">
              JWNET取扱品目
            </div>
            <h4>
              {{ dealDetail.item_name }}&emsp;
            </h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /マニフェスト数量／回収数量／JWNET取り扱い品目 -->
        <!-- 運搬量／確定数量／荷姿 -->
        <v-row dense>
          <v-col cols="12" md="4">
            <div class="overline">
              運搬量
            </div>
            <h4 class="text-right">
              {{ dealDetail.manifest_transport_amount | comma_format }}&emsp;
            </h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="4">
            <div class="overline">
              確定数量
            </div>
            <h4 class="text-right">
              {{ dealDetail.fixed_quantity | comma_format }}&emsp;
            </h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="4">
            <div class="overline">
              荷姿
            </div>
            <h4>
              {{ dealDetail.packing_name }}&emsp;
            </h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /運搬量／確定数量／荷姿 -->
        <!-- 取引数量／取引単位 -->
        <v-row dense>
          <v-col cols="12" md="4">
            <div class="overline">
              取引数量
            </div>
            <h4 class="text-right">
              {{ dealDetail.quantity | comma_format }}&emsp;
            </h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="4">
            <div class="overline">
              取引単位
            </div>
            <h4 class="text-right">
              {{ dealDetail.sales_item_unit_name }}&emsp;
            </h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /取引数量／取引単位 -->
        <!-- 単価／単価単位／課税区分 -->
        <v-row dense>
          <v-col cols="12" md="4">
            <div class="overline">
              単価
            </div>
            <h4 class="text-right">
              {{ dealDetail.unit_price | comma_format }}&emsp;
            </h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="4">
            <div class="overline">
              単位あたり
            </div>
            <h4 class="text-right">
              {{ dealDetail.quantity_per_unit }}&emsp;{{ dealDetail.sales_item_unit_name }}&emsp;
            </h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /単価／単価単位／課税区分 -->
        <!-- 明細金額 -->
        <v-row dense>
          <v-col cols="12" md="4">
            <div class="overline">
              明細金額
            </div>
            <h4 class="text-right">
              {{ dealDetail.detailed_amount | comma_format }}&emsp;
            </h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="4">
            <div class="overline">
              課税区分
            </div>
            <h4>
              {{ dealDetail.tax_type | tax_type }}&emsp;
            </h4>
            <v-divider />
          </v-col>
        </v-row>
        <!-- /明細金額 -->
        <v-row dense>
          <v-col cols="12">
            <div class="overline">
              売上明細備考
            </div>
            <h4>
              {{ dealDetail.detailed_memo }}&emsp;
            </h4>
            <v-divider />
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="closeButtonClickEvent"
        >
          閉じる
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ReferenceDialog',
  components: {},
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
    dealDetail: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {}
  },
  computed: {},
  watch: {
    enableDialog () {},
  },
  created() {
  },
  methods: {
    closeButtonClickEvent () {
      this.$emit('closeCallback')
    }
  }
}
</script>

<style scoped lang="scss">

</style>
